import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc7a5730"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between align-items-center mb-7" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Indicar App", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"20px"},
  class: "m-0 fas fa-arrow-left"
}, null, -1))
const _hoisted_4 = { class: "card p-4 gap-2 d-flex flex-row mb-6" }
const _hoisted_5 = { class: "d-flex flex-column gap-2 col-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tipo", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Mês vigente", -1))
const _hoisted_8 = { class: "d-flex flex-column gap-2 col-6" }
const _hoisted_9 = {
  key: 0,
  class: "text-danger text-bold"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "d-flex flex-row justify-content-end" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  style: {"color":"white"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  style: {"color":"white"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 0,
  class: "col-12 d-flex flex-column p-0"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  style: {"background":"#203972","border-radius":"10px 10px 0px 0px"},
  class: "col-12 p-4 d-flex flex-row"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-white subtitulo col d-flex justify-content-start" }, "Loja"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-white subtitulo col-2 d-flex justify-content-center" }, "Quantidade")
], -1))
const _hoisted_22 = { class: "col d-flex justify-content-start" }
const _hoisted_23 = { class: "col-2 d-flex justify-content-center" }
const _hoisted_24 = {
  key: 1,
  class: "card p-4",
  style: {"height":"70dvh"}
}
const _hoisted_25 = {
  key: 2,
  class: "card p-4 d-flex flex-column align-items-center justify-content-center",
  style: {"height":"50dvh"}
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-list-ul mb-6",
  style: {"font-size":"8rem"}
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "" }, "Faça uma pesquisa", -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Title, null, {
        default: _withCtx(() => [
          _createTextVNode("Uso do "),
          _hoisted_2,
          _createTextVNode(" por loja")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/lojas",
        style: {"height":"fit-content","white-space":"nowrap"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Button, { text: "Voltar" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_el_button_group, { class: "col-10" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "danger",
              class: _normalizeClass([_ctx.show === 'todas' ? 'bg-danger border-bottom border-bottom-success' : '', "col-4"]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = 'todas', _ctx.filtro.tipo  = null ))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Todas consultas")
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_el_button, {
              type: "danger",
              class: _normalizeClass([_ctx.show === 'finalizados' ? 'bg-danger border-bottom border-bottom-success' : '', "col-4"]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show = 'finalizados', _ctx.filtro.tipo  = 'Vendido' ))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Finalizados")
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_el_button, {
              type: "danger",
              class: _normalizeClass([_ctx.show === 'cancelados' ? 'bg-danger border-bottom border-bottom-success' : '', "col-4"]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.show = 'cancelados', _ctx.filtro.tipo  = 'Cancelado' ))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancelados")
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }),
        _hoisted_7,
        _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.filtro.dataInicio,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filtro.dataInicio) = $event)),
              type: "month",
              format: "MM/YYYY",
              placeholder: "MM/DD/AAAA"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["locale"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", null, [
          _createTextVNode("Quantidade minima p/ refêrencia "),
          (_ctx.spanWarning)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "*"))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_el_input_number, {
          modelValue: _ctx.filtro.limite,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filtro.limite) = $event)),
          precision: 0,
          step: 10,
          max: 500,
          "controls-position": "right",
          placeholder: "50"
        }, null, 8, ["modelValue"]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          (_ctx.lojas?.length)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                disabled: _ctx.loadingTicket,
                type: "danger",
                class: "col-3",
                onClick: _ctx.createTickets
              }, {
                default: _withCtx(() => [
                  (!_ctx.loadingTicket)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Gerar tickets"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            type: "danger",
            disabled: _ctx.loading,
            class: "col-3",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getLojasUsoApp(_ctx.filtro)))
          }, {
            default: _withCtx(() => [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Buscar"))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    (_ctx.lojas?.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_20, [
          _hoisted_21,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lojasPaginate, (loja, key) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "listaZebra col-12 d-flex flex-row align-items-center p-2",
              style: {"background":"#ffff"},
              key: key
            }, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(loja.store_name), 1),
              _createElementVNode("div", _hoisted_23, _toDisplayString(loja.quantidade), 1)
            ]))
          }), 128)),
          (_openBlock(), _createBlock(_component_Pagination, {
            key: _ctx.route.path,
            arr: _ctx.lojas,
            totalBanco: _ctx.lojas.length,
            onPaginateFront: _ctx.paginateFront,
            tipo: 'Lojas'
          }, null, 8, ["arr", "totalBanco", "onPaginateFront"]))
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createVNode(_component_el_skeleton, { animated: "" }),
          _createVNode(_component_el_skeleton, { animated: "" }),
          _createVNode(_component_el_skeleton, { animated: "" }),
          _createVNode(_component_el_skeleton, { animated: "" })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.lojas && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_28))
      : _createCommentVNode("", true)
  ]))
}